<template>
  <Draggable
    v-model="localImgList"
    class="deag"
    @end="onDragEnd($event, item)"
    :disabled="item.taskContentType != 'SCDY'"
    item-key="path"
    animation="500"
    delay="100"
    ghost-class="drag-ghost"
    chosen-class="drag-chosen"
    drag-class="drag-dragging"
  >
    <el-tooltip
      :hide-after="1000"
      class="item"
      v-for="(img, index) in imgList"
      :key="index"
      effect="dark"
      :content="img.type"
      placement="top-start"
      transition="el-fade-in"
    >
      <img
        v-if="img.path.indexOf('.docx') > -1 || img.path.indexOf('.doc') > -1"
        @click="prevFile(img.path)"
        class="w-120 h-120 m-r-8 m-t-8"
        src="../../../assets/icon/ic_word.png"
      />
      <img
        v-else-if="
          img.path.indexOf('.xlsx') > -1 || img.path.indexOf('.xls') > -1
        "
        @click="prevFile(img.path)"
        class="w-120 h-120 m-r-8 m-t-8"
        src="../../../assets/icon/ic_excel.png"
      />
      <img
        v-else-if="img.path.indexOf('.pdf') > -1"
        @click="prevFile(img.path)"
        class="w-120 h-120 m-r-8 m-t-8"
        src="../../../assets/images/pdf_icon.png"
      />
      <img
        v-else-if="img.path.indexOf('.mp4') > -1"
        @click="prevVideo(img.path)"
        class="w-120 h-120 m-r-8 m-t-8"
        style="cursor: pointer"
        src="../../../assets/icon/ic_mp4.png"
      />
      <div v-else class="w-120 m-r-8 m-t-8">
        <el-image
          class="flex w-120 h-120 m-r-8 m-t-8"
          :src="img.path"
          :preview-src-list="imgPathList"
        >
        </el-image>
        <!-- 只有待审核 部分合格 不合格  tab 才展示 -->
        <div
          class="img-text font-S12 t-center"
          v-if="showBtn(img)"
          :style="getBgStyle(img, index)"
          @click="onAuditImgDialog(item, img)"
        >
          <div class="flex">
            <div
              :style="isReportMap[isReportEnum.N].bageStyle"
              v-if="img.suspectInfo.reportType != ReportTypeEnum.AI"
              class="text-bage mr5"
            >
              {{ img.suspectInfo.afterSuspectType.length }}
            </div>
            <div class="nowrap-ellipsis w74">
              <!-- 待审核图片系统识别文案 -->
              <span
                v-if="
                  [1].includes(activeTab) &&
                  img.suspectInfo.reportType != ReportTypeEnum.AI
                "
              >
                {{
                  $getNameByKey(
                    img.suspectInfo.afterSuspectType?.[0],
                    "图像识别不合规场景-待审核"
                  )
                }}
              </span>
              <!--部分合格 不合格 文案  -->
              <span
                v-if="
                  [3, 4].includes(activeTab) &&
                  img.suspectInfo.reportType != ReportTypeEnum.AI
                "
              >
                {{
                  $getNameByKey(
                    img.suspectInfo.afterSuspectType?.[0],
                    "图像识别不合规场景-已审核"
                  )
                }}
              </span>
            </div>
          </div>
          <el-button v-if="!img.notSuspectInfo" size="mini" type="text">
            <span class="btn mr5" @click.stop="onReportSuspectPict(item, img)">
              {{
                img.suspectInfo.isReport == isReportEnum.N &&
                img.suspectInfo.reportType == ReportTypeEnum.WAIT_AUDIT
                  ? "AI纠正"
                  : ""
              }}
            </span>
            <CustomDropdown
              v-if="
                img.suspectInfo.isReport == isReportEnum.N &&
                img.suspectInfo.reportType == ReportTypeEnum.WAIT_AUDIT
              "
              :item="img"
              :options="feedbackOptions"
              @confirm="onDropdownConfirm(item, img, $event)"
            />
            <span
              class="btn"
              @click.stop="onReportSuspectPict(item, img)"
              v-if="
                img.suspectInfo.isReport == isReportEnum.Y &&
                img.suspectInfo.reportType == ReportTypeEnum.MANUAL
              "
            >
              取消反馈
            </span>
          </el-button>
        </div>

        <!-- 待审核 部分合格 不合格  tab 情况下 系统没有识别出不合规场景 人工可手动审核 -->
        <div
          class="font-S12 t-center mt10 img-text"
          v-if="[1, 3, 4].includes(activeTab)"
        >
          <el-button size="mini" type="text" v-if="img.notSuspectInfo">
            <CustomDropdown
              :options="feedbackOptions"
              @confirm="onDropdownConfirm(item, img, $event)"
            />
          </el-button>
          <el-button
            size="mini"
            type="text"
            v-if="
              img.suspectInfo.isReport == isReportEnum.Y &&
              img.suspectInfo.reportType == ReportTypeEnum.AI
            "
            @click.stop="onReportSuspectPict(item, img)"
          >
            <span class="btn"> 取消纠错 </span>
          </el-button>
        </div>
      </div>
    </el-tooltip>
  </Draggable>
</template>

<script>
import draggable from "vuedraggable";
import CustomDropdown from "./CustomDropdown.vue";
import { ReportTypeEnum, isReportEnum, isReportMap } from "../enum";

export default {
  components: {
    Draggable: draggable,
    CustomDropdown,
  },
  props: {
    notDrag: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    imgList: {
      type: Array,
      default: () => [],
    },
    imgPathList: {
      type: Array,
      default: () => [],
    },
    onDragEnd: {
      type: Function,
      default: () => {},
    },
    prevFile: {
      type: Function,
      default: () => {},
    },
    prevVideo: {
      type: Function,
      default: () => {},
    },
    activeTab: {
      type: Number,
      default: 1,
    },
    onAuditImgDialog: {
      type: Function,
      default: () => {},
    },
    onReportSuspectPict: {
      type: Function,
      default: () => {},
    },
    feedbackOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ReportTypeEnum,
      isReportEnum,
      isReportMap,
      localImgList: [],
    };
  },
  methods: {
    // 下拉框确认事件
    onDropdownConfirm(item, img, selectedValues) {
      this.onReportSuspectPict(item, img, selectedValues);
    },
    showBtn(img) {
      // 只有待审核 部分合格 不合格  tab 才展示
      // 并且 不是 ai 纠错
      return (
        [1, 3, 4].includes(this.activeTab) &&
        img.suspectInfo?.afterSuspectType?.length &&
        (img.suspectInfo.isReport != this.isReportEnum.Y ||
          img.suspectInfo.reportType != this.ReportTypeEnum.AI)
      );
    },
    getBgStyle(img) {
      if (
        (img.suspectInfo?.reportType != this.ReportTypeEnum.AI &&
          img.suspectInfo?.suspectType?.length) ||
        img.suspectInfo?.reportType == this.ReportTypeEnum.MANUAL
      ) {
        return isReportMap[isReportEnum.N].style;
      } else {
        return isReportMap[isReportEnum.Y].style;
      }
    },
  },
  watch: {
    imgList: {
      deep: true,
      handler(newVal) {
        if (newVal?.length > 0) {
          this.localImgList = newVal;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.w74 {
  width: 74px;
}

.deag {
  display: flex;
  flex-wrap: wrap;
}
.drag-ghost {
  opacity: 0.4;
}
.drag-chosen {
  border: 2px dashed #409eff;
}
.drag-dragging {
  transform: scale(1.05);
}
.w-120 {
  width: 120px;
}
.h-120 {
  height: 120px;
}
.m-r-8 {
  margin-right: 8px;
}
.m-t-8 {
  margin-top: 8px;
}

.img-text {
  align-items: center;
  justify-content: center;
  white-space: normal;
  overflow-wrap: break-word;
  margin-top: 6px;
  padding: 4px 6px;
  .text-bage {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    text-align: center;
  }
  .border-b-1 {
    border-bottom: 1px solid #000;
  }
  .btn {
    color: #212121;
    border-bottom: 1px solid #333;
  }
}
</style>
